import "./MobileIntropage.css";
import IntroText from "../../Components/IntroText";

export default function MobileIntro() {
  return (
    <div className="mobile-p-intro-margin">
      <IntroText />
    </div>
  );
}
